module.exports = __webpack_public_path__ + "static/media/tap_06_img02.c03b00f7.png";